import AgentProfile from 'models/agent_profile';
import createConverter from './lib/create_converter';

export default createConverter(AgentProfile);



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/agent_profile_converter.js